import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import * as ApolloCore from '@apollo/client/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  accountIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyInfo?: Maybe<CompanyInfo>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  sellerCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  supportContact?: Maybe<SupportContact>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AllAccounts = {
  __typename?: 'AllAccounts';
  accountId?: Maybe<Scalars['Int']['output']>;
};

export type AuctionItem = {
  __typename?: 'AuctionItem';
  id?: Maybe<Scalars['Int']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  saleId?: Maybe<Scalars['Int']['output']>;
};

export type AuctionItemInput = {
  airConditioning?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  capacityType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
  itemNotes?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  mounted?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalAddress?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalCity?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalState?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalZip?: InputMaybe<Scalars['String']['input']>;
  optionalEquipment?: InputMaybe<Scalars['String']['input']>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  plateNumber?: InputMaybe<Scalars['String']['input']>;
  sellerFleetNumber2?: InputMaybe<Scalars['String']['input']>;
  taxCounty?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  upperFuel?: InputMaybe<Scalars['String']['input']>;
  upperMake?: InputMaybe<Scalars['String']['input']>;
  upperModel?: InputMaybe<Scalars['String']['input']>;
  upperOptionalEquipment?: InputMaybe<Scalars['String']['input']>;
  upperSerialNumber?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessCode = {
  __typename?: 'BusinessCode';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BusinessInfo = {
  businessAddressLine1?: InputMaybe<Scalars['String']['input']>;
  businessAddressLine2?: InputMaybe<Scalars['String']['input']>;
  businessCity?: InputMaybe<Scalars['String']['input']>;
  businessCountry?: InputMaybe<Scalars['String']['input']>;
  businessCounty?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  businessPhoneType?: InputMaybe<Scalars['String']['input']>;
  businessState?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  businessZip?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerFilterOptions = {
  __typename?: 'BuyerFilterOptions';
  category?: Maybe<Array<Maybe<LookupValues>>>;
  make?: Maybe<Array<Maybe<LookupValues>>>;
  model?: Maybe<Array<Maybe<LookupValues>>>;
  offSitePhysical?: Maybe<Array<Maybe<LookupValues>>>;
  saleInfo?: Maybe<Array<Maybe<LookupValues>>>;
  upperMake?: Maybe<Array<Maybe<LookupValues>>>;
  upperModel?: Maybe<Array<Maybe<LookupValues>>>;
};

export type Capacity = {
  __typename?: 'Capacity';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyCity?: Maybe<Scalars['String']['output']>;
  companyCountry?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  companyState?: Maybe<Scalars['String']['output']>;
  companyZip?: Maybe<Scalars['String']['output']>;
};

export type ContactUsMessage = {
  customerComments?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  mailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<Scalars['String']['input']>;
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Engine = {
  __typename?: 'Engine';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  __typename?: 'Filter';
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FiltersRequest = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type FiltersResponse = {
  __typename?: 'FiltersResponse';
  filterList?: Maybe<Array<Maybe<Filter>>>;
};

export type ForgotPassword = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Fuel = {
  __typename?: 'Fuel';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Geocode = {
  __typename?: 'Geocode';
  objects?: Maybe<Array<Maybe<GeocodeLocation>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GeocodeLocation = {
  __typename?: 'GeocodeLocation';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type InventoryManagementDetailsResponse = {
  __typename?: 'InventoryManagementDetailsResponse';
  assignedItems?: Maybe<Scalars['Int']['output']>;
  auctionReady?: Maybe<Scalars['Int']['output']>;
  awaitingTitle?: Maybe<Scalars['Int']['output']>;
  conditionPending?: Maybe<Scalars['Int']['output']>;
  needsDecommissioning?: Maybe<Scalars['Int']['output']>;
  notOnSite?: Maybe<Scalars['Int']['output']>;
  test?: Maybe<Scalars['Int']['output']>;
};

export type InventorySale = {
  __typename?: 'InventorySale';
  address?: Maybe<Scalars['String']['output']>;
  auctionStatus?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  creditCardConvenienceFee?: Maybe<Scalars['Float']['output']>;
  creditCardsNotAccepted?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['Float']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fee1ADescription?: Maybe<Scalars['String']['output']>;
  fee1Description?: Maybe<Scalars['String']['output']>;
  fee2Description?: Maybe<Scalars['String']['output']>;
  fee3Description?: Maybe<Scalars['String']['output']>;
  fee4Description?: Maybe<Scalars['String']['output']>;
  fee5Description?: Maybe<Scalars['String']['output']>;
  fee6Description?: Maybe<Scalars['String']['output']>;
  fee7Description?: Maybe<Scalars['String']['output']>;
  fee8Description?: Maybe<Scalars['String']['output']>;
  fee9Description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  numberOfRings?: Maybe<Scalars['String']['output']>;
  offSiteItems?: Maybe<Scalars['Boolean']['output']>;
  payoutsFinalized?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  primarySalesContact?: Maybe<Scalars['String']['output']>;
  saleName?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  termsAdditional?: Maybe<Scalars['String']['output']>;
  termsAdditionalPayment?: Maybe<Scalars['String']['output']>;
  termsBuyersFee?: Maybe<Scalars['String']['output']>;
  termsContactInfo?: Maybe<Scalars['String']['output']>;
  termsDesc?: Maybe<Scalars['String']['output']>;
  termsExchangeNotif?: Maybe<Scalars['String']['output']>;
  termsFinancing?: Maybe<Scalars['String']['output']>;
  termsLiveInternetBidding?: Maybe<Scalars['String']['output']>;
  termsLocation?: Maybe<Scalars['String']['output']>;
  termsNotice?: Maybe<Scalars['String']['output']>;
  termsPayment?: Maybe<Scalars['String']['output']>;
  termsRemoval?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  accountId?: Maybe<Scalars['Int']['output']>;
  bidderNumber?: Maybe<Scalars['Int']['output']>;
  bidderType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceBalance?: Maybe<Scalars['Float']['output']>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  invoiceStatus?: Maybe<Scalars['String']['output']>;
  invoiceTotal?: Maybe<Scalars['Float']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  sale?: Maybe<InventorySale>;
  saleId?: Maybe<Scalars['Int']['output']>;
  signatureReceived?: Maybe<Scalars['Boolean']['output']>;
  signatureRequested?: Maybe<Scalars['Boolean']['output']>;
  signatureRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoiceSearchRequest = {
  auctionDateEnd?: InputMaybe<Scalars['String']['input']>;
  auctionDateStart?: InputMaybe<Scalars['String']['input']>;
  auctionLocation?: InputMaybe<Scalars['String']['input']>;
  buyerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceBalance?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceSearchResponse = {
  __typename?: 'InvoiceSearchResponse';
  content?: Maybe<Array<Maybe<Invoice>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Item = {
  __typename?: 'Item';
  accountCode?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  adjustmentAmount?: Maybe<Scalars['Float']['output']>;
  airConditioning?: Maybe<Scalars['Boolean']['output']>;
  amountOwed?: Maybe<Scalars['Float']['output']>;
  arrivalDate?: Maybe<Scalars['Float']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  bidderBuyerInvoiceId?: Maybe<Scalars['Int']['output']>;
  bidderNumber?: Maybe<Scalars['Int']['output']>;
  bidderTotal?: Maybe<Scalars['Float']['output']>;
  bodyDescription?: Maybe<Scalars['String']['output']>;
  buyerAccountId?: Maybe<Scalars['Int']['output']>;
  buyerAccountName?: Maybe<Scalars['String']['output']>;
  buyerFee?: Maybe<Scalars['Float']['output']>;
  buyerPickupDate?: Maybe<Scalars['Float']['output']>;
  buyersTotal?: Maybe<Scalars['Float']['output']>;
  caLicenseFee?: Maybe<Scalars['Float']['output']>;
  caWeightFee?: Maybe<Scalars['Float']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  capacityType?: Maybe<Scalars['String']['output']>;
  catalogDescription?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  decommComplete?: Maybe<Scalars['Boolean']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  expenseDecommission?: Maybe<Scalars['Float']['output']>;
  expenseMisc1?: Maybe<Scalars['Float']['output']>;
  expenseMisc2?: Maybe<Scalars['Float']['output']>;
  expensePartsRepairs?: Maybe<Scalars['Float']['output']>;
  expenseTransportation?: Maybe<Scalars['Float']['output']>;
  expenseWashing?: Maybe<Scalars['Float']['output']>;
  fee1Actual?: Maybe<Scalars['Float']['output']>;
  fee1aActual?: Maybe<Scalars['Float']['output']>;
  fee2Actual?: Maybe<Scalars['Float']['output']>;
  fee2aActual?: Maybe<Scalars['Float']['output']>;
  fee3Actual?: Maybe<Scalars['Float']['output']>;
  fee4Actual?: Maybe<Scalars['Float']['output']>;
  fee5Actual?: Maybe<Scalars['Float']['output']>;
  fee6Actual?: Maybe<Scalars['Float']['output']>;
  fee7Actual?: Maybe<Scalars['Float']['output']>;
  fee8Actual?: Maybe<Scalars['Float']['output']>;
  fee9Actual?: Maybe<Scalars['Float']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  haveTitle?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  industry?: Maybe<Scalars['String']['output']>;
  inspectionDate?: Maybe<Scalars['Float']['output']>;
  inspectionReport?: Maybe<Scalars['Boolean']['output']>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  itemStatus?: Maybe<Scalars['String']['output']>;
  keywordList?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  lotNumberFinal?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedDate?: Maybe<Scalars['Float']['output']>;
  mounted?: Maybe<Scalars['String']['output']>;
  needsDecomm?: Maybe<Scalars['Boolean']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  odometerType?: Maybe<Scalars['String']['output']>;
  offSite?: Maybe<Scalars['Boolean']['output']>;
  offSitePhysicalCity?: Maybe<Scalars['String']['output']>;
  offSitePhysicalState?: Maybe<Scalars['String']['output']>;
  offSitePhysicalZip?: Maybe<Scalars['String']['output']>;
  optionalEquipment?: Maybe<Scalars['String']['output']>;
  parentCategory?: Maybe<Scalars['String']['output']>;
  pickupAddress?: Maybe<Scalars['String']['output']>;
  pickupCity?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['Float']['output']>;
  pickupState?: Maybe<Scalars['String']['output']>;
  pickupZip?: Maybe<Scalars['String']['output']>;
  plateNumber?: Maybe<Scalars['String']['output']>;
  publicDocuments?: Maybe<Scalars['Boolean']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  sale?: Maybe<InventorySale>;
  saleCity?: Maybe<Scalars['String']['output']>;
  saleDate?: Maybe<Scalars['Float']['output']>;
  saleDateString?: Maybe<Scalars['String']['output']>;
  saleId?: Maybe<Scalars['Int']['output']>;
  saleInfo?: Maybe<Scalars['String']['output']>;
  saleName?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  saleState?: Maybe<Scalars['String']['output']>;
  saleType?: Maybe<Scalars['String']['output']>;
  sellerPayoutId?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  titleFee?: Maybe<Scalars['Float']['output']>;
  titleReceivedDate?: Maybe<Scalars['Float']['output']>;
  titled?: Maybe<Scalars['Boolean']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  trueMileageUnknown?: Maybe<Scalars['Boolean']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
  upperBodyDescription?: Maybe<Scalars['String']['output']>;
  upperFuel?: Maybe<Scalars['String']['output']>;
  upperMake?: Maybe<Scalars['String']['output']>;
  upperModel?: Maybe<Scalars['String']['output']>;
  upperOptionalEquipment?: Maybe<Scalars['String']['output']>;
  upperSerialNumber?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  webDescription?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type ItemsSearchResponse = SearchResponse & {
  __typename?: 'ItemsSearchResponse';
  content?: Maybe<Array<Maybe<Item>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type LookupValues = {
  __typename?: 'LookupValues';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MakeAndModel = {
  __typename?: 'MakeAndModel';
  make?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Mounted = {
  __typename?: 'Mounted';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  activateUser?: Maybe<Success>;
  deleteDraftItem?: Maybe<RdsTest>;
  deleteSiteMessage?: Maybe<Success>;
  forgotPassword?: Maybe<Success>;
  register?: Maybe<Success>;
  saveAuctionItem?: Maybe<AuctionItem>;
  saveDraftItem?: Maybe<RdsTest>;
  saveSiteMessage?: Maybe<Success>;
  sendContactUsMessage?: Maybe<Success>;
  updateDraftItem?: Maybe<RdsTest>;
  updateSiteMessage?: Maybe<Success>;
};


export type MutationActivateUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationDeleteDraftItemArgs = {
  draftId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteSiteMessageArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordObject?: InputMaybe<ForgotPassword>;
};


export type MutationRegisterArgs = {
  registrationObject?: InputMaybe<Registration>;
};


export type MutationSaveAuctionItemArgs = {
  accountId: Scalars['Int']['input'];
  auctionItem: AuctionItemInput;
  contactId: Scalars['Int']['input'];
};


export type MutationSaveDraftItemArgs = {
  draftItem?: InputMaybe<RdsDraftItemInput>;
};


export type MutationSaveSiteMessageArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  adminMessage?: InputMaybe<RdsMessageInput>;
};


export type MutationSendContactUsMessageArgs = {
  messageObject?: InputMaybe<ContactUsMessage>;
};


export type MutationUpdateDraftItemArgs = {
  draftItem?: InputMaybe<RdsDraftItemInput>;
};


export type MutationUpdateSiteMessageArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  siteMessage?: InputMaybe<RdsMessageInput>;
};

export type Payout = {
  __typename?: 'Payout';
  accountId?: Maybe<Scalars['Int']['output']>;
  adjustments?: Maybe<Scalars['Float']['output']>;
  advertising?: Maybe<Scalars['Float']['output']>;
  altecSalesCredit?: Maybe<Scalars['Boolean']['output']>;
  checkPayableTo?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  decommission?: Maybe<Scalars['Float']['output']>;
  expense1Amount?: Maybe<Scalars['Float']['output']>;
  expense2Amount?: Maybe<Scalars['Float']['output']>;
  expense3Amount?: Maybe<Scalars['Float']['output']>;
  expense4Amount?: Maybe<Scalars['Float']['output']>;
  expense5Amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  income1Amount?: Maybe<Scalars['Float']['output']>;
  income2Amount?: Maybe<Scalars['Float']['output']>;
  income3Amount?: Maybe<Scalars['Float']['output']>;
  income4Amount?: Maybe<Scalars['Float']['output']>;
  income5Amount?: Maybe<Scalars['Float']['output']>;
  misc1Amount?: Maybe<Scalars['Float']['output']>;
  misc2Amount?: Maybe<Scalars['Float']['output']>;
  partsRepairs?: Maybe<Scalars['Float']['output']>;
  payoutStatus?: Maybe<Scalars['String']['output']>;
  releasePayoutReport?: Maybe<Scalars['Boolean']['output']>;
  revised?: Maybe<Scalars['Boolean']['output']>;
  sale?: Maybe<PayoutSale>;
  saleId?: Maybe<Scalars['Int']['output']>;
  salePriceSubtotal?: Maybe<Scalars['Float']['output']>;
  sellerFee?: Maybe<Scalars['Float']['output']>;
  sellerNet?: Maybe<Scalars['Float']['output']>;
  totalAdjustedNoSaleAmount?: Maybe<Scalars['Float']['output']>;
  totalLots?: Maybe<Scalars['Int']['output']>;
  totalNoSaleAmount?: Maybe<Scalars['Float']['output']>;
  transportation?: Maybe<Scalars['Float']['output']>;
  upsTrackingNumber?: Maybe<Scalars['String']['output']>;
  washing?: Maybe<Scalars['Float']['output']>;
};

export type PayoutFiltersResponse = {
  __typename?: 'PayoutFiltersResponse';
  sale?: Maybe<Array<Maybe<LookupValues>>>;
};

export type PayoutSale = {
  __typename?: 'PayoutSale';
  address?: Maybe<Scalars['String']['output']>;
  adminFee?: Maybe<Scalars['Float']['output']>;
  auctionStatus?: Maybe<Scalars['String']['output']>;
  buyersFeeInternet?: Maybe<Scalars['Float']['output']>;
  buyersFeePercentage?: Maybe<Scalars['Float']['output']>;
  buyersFeeTaxable?: Maybe<Scalars['Boolean']['output']>;
  caAdditionalBuyerFeePercentage?: Maybe<Scalars['Float']['output']>;
  caOOSTitledTax?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contractPrinted?: Maybe<Scalars['Boolean']['output']>;
  copies?: Maybe<Scalars['Float']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  creditCardConvenienceFee?: Maybe<Scalars['Float']['output']>;
  creditCardsNotAccepted?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  defaultEmailAddress?: Maybe<Scalars['String']['output']>;
  defaultEmailName?: Maybe<Scalars['String']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fee1ADescription?: Maybe<Scalars['String']['output']>;
  fee1Description?: Maybe<Scalars['String']['output']>;
  fee2Description?: Maybe<Scalars['String']['output']>;
  fee3Description?: Maybe<Scalars['String']['output']>;
  fee4Description?: Maybe<Scalars['String']['output']>;
  fee5Description?: Maybe<Scalars['String']['output']>;
  fee8Description?: Maybe<Scalars['String']['output']>;
  financialAccountId?: Maybe<Scalars['String']['output']>;
  financialLocationId?: Maybe<Scalars['String']['output']>;
  firstPostDate?: Maybe<Scalars['Date']['output']>;
  gatavtPercent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  invoiceAddress?: Maybe<Scalars['String']['output']>;
  invoiceCity?: Maybe<Scalars['String']['output']>;
  invoiceCountry?: Maybe<Scalars['String']['output']>;
  invoiceFX?: Maybe<Scalars['String']['output']>;
  invoiceState?: Maybe<Scalars['String']['output']>;
  invoiceStateCode?: Maybe<Scalars['String']['output']>;
  invoiceTX?: Maybe<Scalars['String']['output']>;
  invoiceTerms?: Maybe<Scalars['String']['output']>;
  invoiceZipCode?: Maybe<Scalars['String']['output']>;
  invoicesProcessed?: Maybe<Scalars['Boolean']['output']>;
  lastInvoiceProcessingDate?: Maybe<Scalars['Date']['output']>;
  lastPayoutProcessingDate?: Maybe<Scalars['Date']['output']>;
  lastPostDate?: Maybe<Scalars['Date']['output']>;
  leadSources?: Maybe<Scalars['String']['output']>;
  letterOfAuthorizationPrinted?: Maybe<Scalars['Boolean']['output']>;
  lotNumbersAssigned?: Maybe<Scalars['Boolean']['output']>;
  miscPayout1?: Maybe<Scalars['Float']['output']>;
  miscPayout2?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notaryFee?: Maybe<Scalars['Float']['output']>;
  numberOfRings?: Maybe<Scalars['Float']['output']>;
  offSiteItems?: Maybe<Scalars['Boolean']['output']>;
  omitOdometerDisc?: Maybe<Scalars['Boolean']['output']>;
  payoutsFinalized?: Maybe<Scalars['Boolean']['output']>;
  payoutsProcessed?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Scalars['Boolean']['output']>;
  proxibidAuctionId?: Maybe<Scalars['String']['output']>;
  proxibidEnabled?: Maybe<Scalars['Boolean']['output']>;
  receivableNoticeEmailBody?: Maybe<Scalars['String']['output']>;
  receivableNoticeEmailBody2?: Maybe<Scalars['String']['output']>;
  releasePayoutReports?: Maybe<Scalars['Boolean']['output']>;
  reportConfiguration?: Maybe<Scalars['String']['output']>;
  ruleVersion?: Maybe<Scalars['String']['output']>;
  saleName?: Maybe<Scalars['String']['output']>;
  saleNameFormatted?: Maybe<Scalars['String']['output']>;
  saleNameTimedAuctionFormatted?: Maybe<Scalars['String']['output']>;
  saleType?: Maybe<Scalars['String']['output']>;
  showOdometer?: Maybe<Scalars['Boolean']['output']>;
  siteContact?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateTableVersion?: Maybe<Scalars['String']['output']>;
  stateTaxRate?: Maybe<Scalars['Float']['output']>;
  suppressInvoiceDisplay?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  taxCity?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  taxCounty?: Maybe<Scalars['String']['output']>;
  taxState?: Maybe<Scalars['String']['output']>;
  taxVersion?: Maybe<Scalars['String']['output']>;
  termsAdditional?: Maybe<Scalars['String']['output']>;
  termsAdditionalPayment?: Maybe<Scalars['String']['output']>;
  termsBuyersFee?: Maybe<Scalars['String']['output']>;
  termsContactInfo?: Maybe<Scalars['String']['output']>;
  termsDesc?: Maybe<Scalars['String']['output']>;
  termsFinancing?: Maybe<Scalars['String']['output']>;
  termsLiveInternetBidding?: Maybe<Scalars['String']['output']>;
  termsLocation?: Maybe<Scalars['String']['output']>;
  termsNotice?: Maybe<Scalars['String']['output']>;
  termsPayment?: Maybe<Scalars['String']['output']>;
  termsRemoval?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  titleFee?: Maybe<Scalars['Float']['output']>;
  totalLots?: Maybe<Scalars['Float']['output']>;
  unofficialTotal?: Maybe<Scalars['Float']['output']>;
  validAuction?: Maybe<Scalars['Boolean']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PayoutSearchRequest = {
  auctionDateEnd?: InputMaybe<Scalars['String']['input']>;
  auctionDateStart?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  payoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  saleId?: InputMaybe<Scalars['String']['input']>;
  salePriceSubtotalMax?: InputMaybe<Scalars['Float']['input']>;
  salePriceSubtotalMin?: InputMaybe<Scalars['Float']['input']>;
  sellerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sellerNetMax?: InputMaybe<Scalars['Float']['input']>;
  sellerNetMin?: InputMaybe<Scalars['Float']['input']>;
  sellerPayoutId?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutSearchResponse = {
  __typename?: 'PayoutSearchResponse';
  content?: Maybe<Array<Maybe<Payout>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PersonalInfo = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  personalAddressLine1?: InputMaybe<Scalars['String']['input']>;
  personalAddressLine2?: InputMaybe<Scalars['String']['input']>;
  personalCity?: InputMaybe<Scalars['String']['input']>;
  personalCountry?: InputMaybe<Scalars['String']['input']>;
  personalCounty?: InputMaybe<Scalars['String']['input']>;
  personalPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  personalPhoneType?: InputMaybe<Scalars['String']['input']>;
  personalState?: InputMaybe<Scalars['String']['input']>;
  personalZip?: InputMaybe<Scalars['String']['input']>;
};

export type Profile = {
  __typename?: 'Profile';
  accountInfo?: Maybe<AccountInfo>;
  defaultContact?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  assignedItemsCount?: Maybe<Scalars['Int']['output']>;
  auctionReadyCount?: Maybe<Scalars['Int']['output']>;
  awaitingTitleCount?: Maybe<Scalars['Int']['output']>;
  businessCodes?: Maybe<Array<Maybe<BusinessCode>>>;
  buyerFilterOptions?: Maybe<BuyerFilterOptions>;
  capacity?: Maybe<Array<Maybe<Capacity>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  conditionPendingCount?: Maybe<Scalars['Int']['output']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  currentRegisteredAuctions?: Maybe<Scalars['Float']['output']>;
  draftFilterValues?: Maybe<RdsFilters>;
  engines?: Maybe<Array<Maybe<Engine>>>;
  estimatedPurchaseBalance?: Maybe<Scalars['Float']['output']>;
  exportItems?: Maybe<Array<Maybe<Item>>>;
  fuel?: Maybe<Array<Maybe<Fuel>>>;
  geocode?: Maybe<Geocode>;
  inventoryManagementDetails?: Maybe<InventoryManagementDetailsResponse>;
  invoiceSaleLocations?: Maybe<Array<Maybe<LookupValues>>>;
  itemDetails?: Maybe<Item>;
  itemFilters?: Maybe<FiltersResponse>;
  makeAndModel?: Maybe<Array<Maybe<MakeAndModel>>>;
  mounted?: Maybe<Array<Maybe<Mounted>>>;
  needsDecommissioningCount?: Maybe<Scalars['Int']['output']>;
  notOnSiteCount?: Maybe<Scalars['Int']['output']>;
  payoutDetails?: Maybe<PayoutSearchResponse>;
  payoutFilters?: Maybe<PayoutFiltersResponse>;
  profiles?: Maybe<Array<Maybe<Profile>>>;
  queryDraftItems?: Maybe<RdsDraftSearchResponse>;
  recentAuctions?: Maybe<Array<Maybe<RecentAuction>>>;
  scanSiteMessages?: Maybe<Array<Maybe<SiteMessage>>>;
  searchInvoices?: Maybe<InvoiceSearchResponse>;
  searchItems?: Maybe<ItemsSearchResponse>;
  searchPayouts?: Maybe<PayoutSearchResponse>;
  sellerFilterOptions?: Maybe<SellerFilterOptions>;
  subcategories?: Maybe<Array<Maybe<Subcategory>>>;
  transmissions?: Maybe<Array<Maybe<Transmission>>>;
  upcomingAuctions?: Maybe<Array<Maybe<Sale>>>;
  upperFuel?: Maybe<Array<Maybe<UpperFuel>>>;
  upperMakeAndModel?: Maybe<Array<Maybe<UpperMakeAndModel>>>;
  ytdSales?: Maybe<Scalars['Float']['output']>;
};


export type QueryAssignedItemsCountArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryAuctionReadyCountArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryAwaitingTitleCountArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryBuyerFilterOptionsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryConditionPendingCountArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryCurrentRegisteredAuctionsArgs = {
  searchObject?: InputMaybe<InvoiceSearchRequest>;
};


export type QueryDraftFilterValuesArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryEstimatedPurchaseBalanceArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryExportItemsArgs = {
  exportEndPage: Scalars['Int']['input'];
  exportStartPage: Scalars['Int']['input'];
  searchObject: SearchItems;
};


export type QueryGeocodeArgs = {
  zip: Scalars['String']['input'];
};


export type QueryInventoryManagementDetailsArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryInvoiceSaleLocationsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryItemDetailsArgs = {
  buyerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  itemId: Scalars['Int']['input'];
  sellerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryItemFiltersArgs = {
  filtersRequest?: InputMaybe<FiltersRequest>;
};


export type QueryNeedsDecommissioningCountArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryNotOnSiteCountArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryPayoutDetailsArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
  payoutId: Scalars['Int']['input'];
};


export type QueryPayoutFiltersArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryProfilesArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQueryDraftItemsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchOptions?: InputMaybe<SearchOptions>;
};


export type QueryRecentAuctionsArgs = {
  buyerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sellerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryScanSiteMessagesArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchInvoicesArgs = {
  searchObject: InvoiceSearchRequest;
};


export type QuerySearchItemsArgs = {
  searchObject: SearchItems;
};


export type QuerySearchPayoutsArgs = {
  searchRequest: PayoutSearchRequest;
};


export type QuerySellerFilterOptionsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryUpcomingAuctionsArgs = {
  accountIds: Array<InputMaybe<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryYtdSalesArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RdsDraftItem = {
  __typename?: 'RDSDraftItem';
  airConditioning?: Maybe<Scalars['Boolean']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  capacityType?: Maybe<Scalars['String']['output']>;
  capacityUnit?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemNotes?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  mounted?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  offSitePhysicalAddress?: Maybe<Scalars['String']['output']>;
  offSitePhysicalCity?: Maybe<Scalars['String']['output']>;
  offSitePhysicalState?: Maybe<Scalars['String']['output']>;
  offSitePhysicalZip?: Maybe<Scalars['String']['output']>;
  optionalEquipment?: Maybe<Scalars['String']['output']>;
  parentCategory?: Maybe<Scalars['String']['output']>;
  plateNumber?: Maybe<Scalars['String']['output']>;
  sellerFleetNumber2?: Maybe<Scalars['String']['output']>;
  submitTimestamp?: Maybe<Scalars['String']['output']>;
  taxCounty?: Maybe<Scalars['String']['output']>;
  titled?: Maybe<Scalars['Boolean']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
  upperFuel?: Maybe<Scalars['String']['output']>;
  upperMake?: Maybe<Scalars['String']['output']>;
  upperModel?: Maybe<Scalars['String']['output']>;
  upperOptionalEquipment?: Maybe<Scalars['String']['output']>;
  upperSerialNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type RdsDraftItemInput = {
  airConditioning?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  capacityType?: InputMaybe<Scalars['String']['input']>;
  capacityUnit?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  currentStep?: InputMaybe<Scalars['Int']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemNotes?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  mounted?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalAddress?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalCity?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalState?: InputMaybe<Scalars['String']['input']>;
  offSitePhysicalZip?: InputMaybe<Scalars['String']['input']>;
  optionalEquipment?: InputMaybe<Scalars['String']['input']>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  plateNumber?: InputMaybe<Scalars['String']['input']>;
  sellerFleetNumber2?: InputMaybe<Scalars['String']['input']>;
  submitTimestamp?: InputMaybe<Scalars['String']['input']>;
  taxCounty?: InputMaybe<Scalars['String']['input']>;
  titled?: InputMaybe<Scalars['Boolean']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  upperFuel?: InputMaybe<Scalars['String']['input']>;
  upperMake?: InputMaybe<Scalars['String']['input']>;
  upperModel?: InputMaybe<Scalars['String']['input']>;
  upperOptionalEquipment?: InputMaybe<Scalars['String']['input']>;
  upperSerialNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type RdsDraftSearchResponse = {
  __typename?: 'RDSDraftSearchResponse';
  records?: Maybe<Array<Maybe<RdsDraftItem>>>;
};

export type RdsFilters = {
  __typename?: 'RDSFilters';
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  make?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  model?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  upperMake?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  upperModel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RdsMessageInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sitePlacement?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submitTimestamp?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RdsTest = {
  __typename?: 'RDSTest';
  test?: Maybe<Scalars['String']['output']>;
};

export type RecentAuction = {
  __typename?: 'RecentAuction';
  invoice?: Maybe<Invoice>;
  payout?: Maybe<Payout>;
  sale?: Maybe<Sale>;
};

export type Registration = {
  businessInfo?: InputMaybe<BusinessInfo>;
  individual?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  personalInfo?: InputMaybe<PersonalInfo>;
  recaptcha?: InputMaybe<Scalars['String']['input']>;
};

export type Sale = {
  __typename?: 'Sale';
  auctionStatus?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  proxibidAuctionId?: Maybe<Scalars['String']['output']>;
  saleName?: Maybe<Scalars['String']['output']>;
  saleType?: Maybe<Scalars['String']['output']>;
  sellerHasItems?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type SearchItems = {
  buyerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  cpStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryManagementStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  offSitePhysical?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  payoutIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  saleInfo?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sellerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  upperMake?: InputMaybe<Scalars['String']['input']>;
  upperModel?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOptions = {
  backEndSortResult?: InputMaybe<Scalars['String']['input']>;
  filterResults?: InputMaybe<Array<InputMaybe<SelectedFilter>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortResults?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResponse = {
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type SelectedFilter = {
  backEndFilter?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
};

export type SellerFilterOptions = {
  __typename?: 'SellerFilterOptions';
  category?: Maybe<Array<Maybe<LookupValues>>>;
  make?: Maybe<Array<Maybe<LookupValues>>>;
  model?: Maybe<Array<Maybe<LookupValues>>>;
  offSitePhysical?: Maybe<Array<Maybe<LookupValues>>>;
  saleInfo?: Maybe<Array<Maybe<LookupValues>>>;
  upperMake?: Maybe<Array<Maybe<LookupValues>>>;
};

export type SiteMessage = {
  __typename?: 'SiteMessage';
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sitePlacement?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submitTimestamp?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SiteMessageId = {
  __typename?: 'SiteMessageID';
  messageId?: Maybe<Scalars['Int']['output']>;
};

export type Subcategory = {
  __typename?: 'Subcategory';
  combination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentCategoryName?: Maybe<Scalars['String']['output']>;
};

export type Success = {
  __typename?: 'Success';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SupportContact = {
  __typename?: 'SupportContact';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Transmission = {
  __typename?: 'Transmission';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UpperFuel = {
  __typename?: 'UpperFuel';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UpperMakeAndModel = {
  __typename?: 'UpperMakeAndModel';
  make?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SaveSiteMessagesMutationVariables = Exact<{
  accountID?: InputMaybe<Scalars['Int']['input']>;
  adminMessage?: InputMaybe<RdsMessageInput>;
}>;


export type SaveSiteMessagesMutation = { __typename?: 'Mutation', saveSiteMessage?: { __typename?: 'Success', success?: boolean | null } | null };

export type UpdateSiteMessagesMutationVariables = Exact<{
  accountID?: InputMaybe<Scalars['Int']['input']>;
  siteMessage?: InputMaybe<RdsMessageInput>;
}>;


export type UpdateSiteMessagesMutation = { __typename?: 'Mutation', updateSiteMessage?: { __typename?: 'Success', success?: boolean | null } | null };

export type SiteMessageQueryVariables = Exact<{
  accountID?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SiteMessageQuery = { __typename?: 'Query', scanSiteMessages?: Array<{ __typename?: 'SiteMessage', id?: number | null, userId?: string | null, submitTimestamp?: string | null, title?: string | null, message?: string | null, status?: string | null, level?: string | null, sitePlacement?: string | null, endDate?: string | null, startDate?: string | null } | null> | null };

export type DeleteSiteMessageMutationVariables = Exact<{
  accountID?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteSiteMessageMutation = { __typename?: 'Mutation', deleteSiteMessage?: { __typename?: 'Success', success?: boolean | null } | null };

export type YtdSalesQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type YtdSalesQuery = { __typename?: 'Query', ytdSales?: number | null };

export type SaleSummaryFragment = { __typename?: 'Sale', id?: number | null, saleName?: string | null, date?: any | null, startTime?: any | null, endTime?: any | null, auctionStatus?: string | null, saleType?: string | null, city?: string | null, state?: string | null, sellerHasItems?: boolean | null, itemCount?: number | null };

export type GetUpcomingAuctionsQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUpcomingAuctionsQuery = { __typename?: 'Query', upcomingAuctions?: Array<{ __typename?: 'Sale', sellerHasItems?: boolean | null, id?: number | null, saleName?: string | null, date?: any | null, startTime?: any | null, endTime?: any | null, auctionStatus?: string | null, saleType?: string | null, city?: string | null, state?: string | null, itemCount?: number | null } | null> | null };

export type GetRecentAuctionsQueryVariables = Exact<{
  buyerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  sellerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentAuctionsQuery = { __typename?: 'Query', recentAuctions?: Array<{ __typename?: 'RecentAuction', sale?: { __typename?: 'Sale', itemCount?: number | null, id?: number | null, saleName?: string | null, date?: any | null, startTime?: any | null, endTime?: any | null, auctionStatus?: string | null, saleType?: string | null, city?: string | null, state?: string | null, sellerHasItems?: boolean | null } | null, payout?: { __typename?: 'Payout', id?: number | null, accountId?: number | null, payoutStatus?: string | null, saleId?: number | null, sellerNet?: number | null, totalLots?: number | null, sale?: { __typename?: 'PayoutSale', payoutsFinalized?: boolean | null } | null } | null, invoice?: { __typename?: 'Invoice', id?: number | null, accountId?: number | null, invoiceTotal?: number | null } | null } | null> | null };

export type GetInventoryManagementDetailsQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInventoryManagementDetailsQuery = { __typename?: 'Query', inventoryManagementDetails?: { __typename?: 'InventoryManagementDetailsResponse', notOnSite?: number | null, conditionPending?: number | null, awaitingTitle?: number | null, auctionReady?: number | null, needsDecommissioning?: number | null, assignedItems?: number | null } | null };

export type GetEstimatedPurchaseBalanceQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type GetEstimatedPurchaseBalanceQuery = { __typename?: 'Query', estimatedPurchaseBalance?: number | null };

export type GetCurrentRegisteredAuctionsQueryVariables = Exact<{
  searchObject: InvoiceSearchRequest;
}>;


export type GetCurrentRegisteredAuctionsQuery = { __typename?: 'Query', currentRegisteredAuctions?: number | null };

export type GetNotOnSiteCountQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotOnSiteCountQuery = { __typename?: 'Query', notOnSiteCount?: number | null };

export type GetConditionPendingCountQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetConditionPendingCountQuery = { __typename?: 'Query', conditionPendingCount?: number | null };

export type GetAwaitingTitleCountQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAwaitingTitleCountQuery = { __typename?: 'Query', awaitingTitleCount?: number | null };

export type GetAuctionReadyCountQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAuctionReadyCountQuery = { __typename?: 'Query', auctionReadyCount?: number | null };

export type GetNeedsDecommissioningCountQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNeedsDecommissioningCountQuery = { __typename?: 'Query', needsDecommissioningCount?: number | null };

export type GetAssignedItemsCountQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAssignedItemsCountQuery = { __typename?: 'Query', assignedItemsCount?: number | null };

export type SearchInvoicesQueryVariables = Exact<{
  searchObject: InvoiceSearchRequest;
}>;


export type SearchInvoicesQuery = { __typename?: 'Query', searchInvoices?: { __typename?: 'InvoiceSearchResponse', number?: number | null, totalElements?: number | null, content?: Array<{ __typename?: 'Invoice', id?: number | null, accountId?: number | null, invoiceNumber?: number | null, invoiceTotal?: number | null, bidderNumber?: number | null, invoiceBalance?: number | null, sale?: { __typename?: 'InventorySale', date?: number | null, city?: string | null, state?: string | null } | null } | null> | null } | null };

export type InvoiceSaleLocationsQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type InvoiceSaleLocationsQuery = { __typename?: 'Query', invoiceSaleLocations?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null };

export type SearchItemsQueryVariables = Exact<{
  searchObject: SearchItems;
}>;


export type SearchItemsQuery = { __typename?: 'Query', searchItems?: { __typename?: 'ItemsSearchResponse', number?: number | null, pageSize?: number | null, totalElements?: number | null, last?: boolean | null, first?: boolean | null, totalPages?: number | null, numberOfElements?: number | null, content?: Array<{ __typename?: 'Item', id?: number | null, amountOwed?: number | null, bidderBuyerInvoiceId?: number | null, buyerAccountId?: number | null, buyersTotal?: number | null, catalogDescription?: string | null, category?: string | null, engine?: string | null, fuel?: string | null, haveTitle?: boolean | null, height?: string | null, imageCount?: number | null, itemId?: string | null, itemStatus?: string | null, lotNumber?: string | null, make?: string | null, model?: string | null, mounted?: string | null, odometer?: string | null, offSitePhysicalCity?: string | null, offSitePhysicalState?: string | null, offSitePhysicalZip?: string | null, parentCategory?: string | null, saleDate?: number | null, saleId?: number | null, saleInfo?: string | null, saleName?: string | null, salePrice?: number | null, saleType?: string | null, sellerPayoutId?: number | null, titled?: boolean | null, transmission?: string | null, unitNumber?: string | null, upperMake?: string | null, upperModel?: string | null, upperOptionalEquipment?: string | null, upperSerialNumber?: string | null, vin?: string | null, year?: string | null, sale?: { __typename?: 'InventorySale', payoutsFinalized?: boolean | null } | null } | null> | null } | null };

export type SellerFilterOptionsQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type SellerFilterOptionsQuery = { __typename?: 'Query', sellerFilterOptions?: { __typename?: 'SellerFilterOptions', saleInfo?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, offSitePhysical?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, category?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, make?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, model?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, upperMake?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null } | null };

export type BuyerFilterOptionsQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type BuyerFilterOptionsQuery = { __typename?: 'Query', buyerFilterOptions?: { __typename?: 'BuyerFilterOptions', saleInfo?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, offSitePhysical?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, category?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, make?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, model?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, upperMake?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null, upperModel?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null } | null };

export type ItemDetailsQueryVariables = Exact<{
  sellerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  buyerAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  itemId: Scalars['Int']['input'];
}>;


export type ItemDetailsQuery = { __typename?: 'Query', itemDetails?: { __typename?: 'Item', id?: number | null, unitNumber?: string | null, itemStatus?: string | null, needsDecomm?: boolean | null, decommComplete?: boolean | null, salePrice?: number | null, lotNumber?: string | null, saleInfo?: string | null, saleType?: string | null, saleDate?: number | null, catalogDescription?: string | null, category?: string | null, vin?: string | null, year?: string | null, make?: string | null, model?: string | null, itemId?: string | null, engine?: string | null, fuel?: string | null, transmission?: string | null, odometer?: string | null, upperSerialNumber?: string | null, upperMake?: string | null, upperModel?: string | null, height?: string | null, mounted?: string | null, upperOptionalEquipment?: string | null, plateNumber?: string | null, conditions?: string | null, optionalEquipment?: string | null, capacity?: string | null, capacityType?: string | null, upperFuel?: string | null, hours?: string | null, offSite?: boolean | null, offSitePhysicalCity?: string | null, offSitePhysicalState?: string | null, offSitePhysicalZip?: string | null, commission?: number | null, expenseTransportation?: number | null, expenseWashing?: number | null, expenseDecommission?: number | null, adjustmentAmount?: number | null, expensePartsRepairs?: number | null, expenseMisc1?: number | null, expenseMisc2?: number | null, amountOwed?: number | null, imageUrls?: Array<string | null> | null, haveTitle?: boolean | null, titled?: boolean | null, inspectionDate?: number | null, titleReceivedDate?: number | null, createDate?: number | null, sellerPayoutId?: number | null, bidderBuyerInvoiceId?: number | null, bidderNumber?: number | null, buyerFee?: number | null, tax?: number | null, caWeightFee?: number | null, caLicenseFee?: number | null, titleFee?: number | null, fee1aActual?: number | null, fee1Actual?: number | null, fee2aActual?: number | null, fee2Actual?: number | null, fee3Actual?: number | null, fee4Actual?: number | null, fee5Actual?: number | null, fee6Actual?: number | null, fee7Actual?: number | null, fee8Actual?: number | null, fee9Actual?: number | null, saleId?: number | null, buyerAccountId?: number | null, arrivalDate?: number | null, sale?: { __typename?: 'InventorySale', payoutsFinalized?: boolean | null, fee1ADescription?: string | null, fee1Description?: string | null, fee2Description?: string | null, fee3Description?: string | null, fee4Description?: string | null, fee5Description?: string | null, fee6Description?: string | null, fee7Description?: string | null, fee8Description?: string | null, fee9Description?: string | null } | null } | null };

export type GetSellerItemsExportDataQueryVariables = Exact<{
  searchObject: SearchItems;
  exportStartPage: Scalars['Int']['input'];
  exportEndPage: Scalars['Int']['input'];
}>;


export type GetSellerItemsExportDataQuery = { __typename?: 'Query', exportItems?: Array<{ __typename?: 'Item', id?: number | null, arrivalDate?: number | null, conditions?: string | null, haveTitle?: boolean | null, itemStatus?: string | null, unitNumber?: string | null, category?: string | null, vin?: string | null, year?: string | null, make?: string | null, model?: string | null, lotNumber?: string | null, saleInfo?: string | null, saleType?: string | null, saleDate?: number | null, offSitePhysicalCity?: string | null, offSitePhysicalState?: string | null, catalogDescription?: string | null, plateNumber?: string | null, engine?: string | null, fuel?: string | null, transmission?: string | null, titled?: boolean | null, odometer?: string | null, hours?: string | null, optionalEquipment?: string | null, upperSerialNumber?: string | null, upperMake?: string | null, upperModel?: string | null, upperFuel?: string | null, height?: string | null, capacity?: string | null, mounted?: string | null, upperOptionalEquipment?: string | null, amountOwed?: number | null, salePrice?: number | null, sale?: { __typename?: 'InventorySale', payoutsFinalized?: boolean | null } | null } | null> | null };

export type GetBuyerItemsExportDataQueryVariables = Exact<{
  searchObject: SearchItems;
  exportStartPage: Scalars['Int']['input'];
  exportEndPage: Scalars['Int']['input'];
}>;


export type GetBuyerItemsExportDataQuery = { __typename?: 'Query', exportItems?: Array<{ __typename?: 'Item', id?: number | null, lotNumber?: string | null, saleName?: string | null, saleDate?: number | null, parentCategory?: string | null, category?: string | null, catalogDescription?: string | null, vin?: string | null, upperSerialNumber?: string | null, odometer?: string | null, hours?: string | null, titled?: boolean | null, buyerPickupDate?: number | null, offSitePhysicalCity?: string | null, offSitePhysicalState?: string | null, offSitePhysicalZip?: string | null, salePrice?: number | null, buyersTotal?: number | null } | null> | null };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordObject?: InputMaybe<ForgotPassword>;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'Success', success?: boolean | null } | null };

export type SearchPayoutsQueryVariables = Exact<{
  searchRequest: PayoutSearchRequest;
}>;


export type SearchPayoutsQuery = { __typename?: 'Query', searchPayouts?: { __typename?: 'PayoutSearchResponse', numberOfElements?: number | null, totalElements?: number | null, content?: Array<{ __typename?: 'Payout', id?: number | null, sellerNet?: number | null, salePriceSubtotal?: number | null, upsTrackingNumber?: string | null, accountId?: number | null, totalAdjustedNoSaleAmount?: number | null, sale?: { __typename?: 'PayoutSale', payoutsFinalized?: boolean | null, city?: string | null, state?: string | null, date?: any | null, saleType?: string | null } | null } | null> | null } | null };

export type GetPayoutDetailsQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  payoutId: Scalars['Int']['input'];
}>;


export type GetPayoutDetailsQuery = { __typename?: 'Query', payoutDetails?: { __typename?: 'PayoutSearchResponse', numberOfElements?: number | null, totalElements?: number | null, content?: Array<{ __typename?: 'Payout', id?: number | null, sellerNet?: number | null, salePriceSubtotal?: number | null, upsTrackingNumber?: string | null, accountId?: number | null, totalAdjustedNoSaleAmount?: number | null, sale?: { __typename?: 'PayoutSale', payoutsFinalized?: boolean | null, city?: string | null, state?: string | null, date?: any | null, saleType?: string | null } | null } | null> | null } | null };

export type GetPayoutFiltersQueryVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPayoutFiltersQuery = { __typename?: 'Query', payoutFilters?: { __typename?: 'PayoutFiltersResponse', sale?: Array<{ __typename?: 'LookupValues', name?: string | null, description?: string | null } | null> | null } | null };

export type PayoutFragment = { __typename?: 'Payout', id?: number | null, sellerNet?: number | null, salePriceSubtotal?: number | null, upsTrackingNumber?: string | null, accountId?: number | null, totalAdjustedNoSaleAmount?: number | null, sale?: { __typename?: 'PayoutSale', payoutsFinalized?: boolean | null, city?: string | null, state?: string | null, date?: any | null, saleType?: string | null } | null };

export type GetBusinessCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessCodesQuery = { __typename?: 'Query', businessCodes?: Array<{ __typename?: 'BusinessCode', id?: number | null, name?: string | null } | null> | null };

export type GeocodeQueryVariables = Exact<{
  zip: Scalars['String']['input'];
}>;


export type GeocodeQuery = { __typename?: 'Query', geocode?: { __typename?: 'Geocode', success?: boolean | null, objects?: Array<{ __typename?: 'GeocodeLocation', city?: string | null, county?: string | null, state?: string | null } | null> | null } | null };

export type RegisterMutationVariables = Exact<{
  registrationObject: Registration;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: { __typename?: 'Success', success?: boolean | null } | null };

export type ActivateUserMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser?: { __typename?: 'Success', success?: boolean | null } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', code?: string | null, description?: string | null } | null> | null };

export type GetContactInfoQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactInfoQuery = { __typename?: 'Query', profiles?: Array<{ __typename?: 'Profile', parentAccountId?: number | null, defaultContact?: number | null, accountInfo?: { __typename?: 'AccountInfo', firstName?: string | null, lastName?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, country?: string | null, phoneNumber?: string | null, phoneType?: string | null, email?: string | null, sellerCode?: string | null, companyInfo?: { __typename?: 'CompanyInfo', companyName?: string | null, companyId?: number | null, companyPhone?: string | null, companyCity?: string | null, companyCountry?: string | null, companyAddress?: string | null, companyState?: string | null, companyZip?: string | null } | null, supportContact?: { __typename?: 'SupportContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null } | null } | null> | null };

export type SendContactUsMessageMutationMutationVariables = Exact<{
  messageObject?: InputMaybe<ContactUsMessage>;
}>;


export type SendContactUsMessageMutationMutation = { __typename?: 'Mutation', sendContactUsMessage?: { __typename?: 'Success', success?: boolean | null } | null };

export type AccountInfoFragment = { __typename?: 'AccountInfo', firstName?: string | null, lastName?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, country?: string | null, phoneNumber?: string | null, phoneType?: string | null, email?: string | null, sellerCode?: string | null, companyInfo?: { __typename?: 'CompanyInfo', companyName?: string | null, companyId?: number | null, companyPhone?: string | null, companyCity?: string | null, companyCountry?: string | null, companyAddress?: string | null, companyState?: string | null, companyZip?: string | null } | null, supportContact?: { __typename?: 'SupportContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null };

export type CompanyInfoFragment = { __typename?: 'CompanyInfo', companyName?: string | null, companyId?: number | null, companyPhone?: string | null, companyCity?: string | null, companyCountry?: string | null, companyAddress?: string | null, companyState?: string | null, companyZip?: string | null };

export type SupportContactFragment = { __typename?: 'SupportContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null };

export type GetDropdownValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDropdownValuesQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', name?: string | null } | null> | null, subcategories?: Array<{ __typename?: 'Subcategory', id?: number | null, name?: string | null, parentCategoryName?: string | null, combination?: string | null } | null> | null, makeAndModel?: Array<{ __typename?: 'MakeAndModel', make?: string | null, models?: Array<string | null> | null } | null> | null, engines?: Array<{ __typename?: 'Engine', id?: number | null, name?: string | null } | null> | null, fuel?: Array<{ __typename?: 'Fuel', id?: number | null, name?: string | null } | null> | null, transmissions?: Array<{ __typename?: 'Transmission', id?: number | null, name?: string | null } | null> | null, upperMakeAndModel?: Array<{ __typename?: 'UpperMakeAndModel', make?: string | null, models?: Array<string | null> | null } | null> | null, upperFuel?: Array<{ __typename?: 'UpperFuel', id?: number | null, name?: string | null } | null> | null, capacity?: Array<{ __typename?: 'Capacity', id?: number | null, name?: string | null, description?: string | null, type?: string | null } | null> | null, mounted?: Array<{ __typename?: 'Mounted', id?: number | null, name?: string | null, type?: string | null } | null> | null };

export type SaveItemMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  contactId: Scalars['Int']['input'];
  auctionItem: AuctionItemInput;
}>;


export type SaveItemMutation = { __typename?: 'Mutation', saveAuctionItem?: { __typename?: 'AuctionItem', id?: number | null, saleId?: number | null, make?: string | null, model?: string | null } | null };

export type DraftItemsQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  searchOptions?: InputMaybe<SearchOptions>;
}>;


export type DraftItemsQuery = { __typename?: 'Query', queryDraftItems?: { __typename?: 'RDSDraftSearchResponse', records?: Array<{ __typename?: 'RDSDraftItem', id?: number | null, userId?: string | null, currentStep?: number | null, itemType?: string | null, submitTimestamp?: string | null, parentCategory?: string | null, category?: string | null, vin?: string | null, year?: string | null, make?: string | null, model?: string | null, sellerFleetNumber2?: string | null, plateNumber?: string | null, engine?: string | null, fuel?: string | null, transmission?: string | null, odometer?: string | null, hours?: string | null, optionalEquipment?: string | null, airConditioning?: boolean | null, unitNumber?: string | null, upperSerialNumber?: string | null, upperMake?: string | null, upperModel?: string | null, upperFuel?: string | null, height?: string | null, capacity?: string | null, capacityUnit?: string | null, capacityType?: string | null, mounted?: string | null, upperOptionalEquipment?: string | null, itemNotes?: string | null, offSitePhysicalAddress?: string | null, offSitePhysicalCity?: string | null, offSitePhysicalState?: string | null, offSitePhysicalZip?: string | null, taxCounty?: string | null, titled?: boolean | null } | null> | null } | null };

export type DraftFilterValuesQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type DraftFilterValuesQuery = { __typename?: 'Query', draftFilterValues?: { __typename?: 'RDSFilters', category?: Array<string | null> | null, make?: Array<string | null> | null, model?: Array<string | null> | null, upperMake?: Array<string | null> | null, upperModel?: Array<string | null> | null } | null };

export type SaveDraftItemsMutationVariables = Exact<{
  draftItem?: InputMaybe<RdsDraftItemInput>;
}>;


export type SaveDraftItemsMutation = { __typename?: 'Mutation', saveDraftItem?: { __typename?: 'RDSTest', test?: string | null } | null };

export type UpdateDraftItemMutationVariables = Exact<{
  draftItem?: InputMaybe<RdsDraftItemInput>;
}>;


export type UpdateDraftItemMutation = { __typename?: 'Mutation', updateDraftItem?: { __typename?: 'RDSTest', test?: string | null } | null };

export type DeleteDraftItemMutationVariables = Exact<{
  draftId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteDraftItemMutation = { __typename?: 'Mutation', deleteDraftItem?: { __typename?: 'RDSTest', test?: string | null } | null };

export const SaleSummaryFragmentDoc = gql`
    fragment SaleSummary on Sale {
  id
  saleName
  date
  startTime
  endTime
  auctionStatus
  saleType
  city
  state
  sellerHasItems
  itemCount
}
    `;
export const PayoutFragmentDoc = gql`
    fragment Payout on Payout {
  id
  sellerNet
  salePriceSubtotal
  upsTrackingNumber
  accountId
  totalAdjustedNoSaleAmount
  sale {
    payoutsFinalized
    city
    state
    date
    saleType
  }
}
    `;
export const CompanyInfoFragmentDoc = gql`
    fragment CompanyInfo on CompanyInfo {
  companyName
  companyId
  companyPhone
  companyCity
  companyCountry
  companyAddress
  companyState
  companyZip
}
    `;
export const SupportContactFragmentDoc = gql`
    fragment SupportContact on SupportContact {
  firstName
  lastName
  email
  phoneNumber
}
    `;
export const AccountInfoFragmentDoc = gql`
    fragment AccountInfo on AccountInfo {
  firstName
  lastName
  address
  city
  state
  zip
  county
  country
  phoneNumber
  phoneType
  email
  sellerCode
  companyInfo {
    ...CompanyInfo
  }
  supportContact {
    ...SupportContact
  }
}
    ${CompanyInfoFragmentDoc}
${SupportContactFragmentDoc}`;
export const SaveSiteMessagesDocument = gql`
    mutation SaveSiteMessages($accountID: Int, $adminMessage: RDSMessageInput) {
  saveSiteMessage(accountID: $accountID, adminMessage: $adminMessage) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveSiteMessagesGQL extends Apollo.Mutation<SaveSiteMessagesMutation, SaveSiteMessagesMutationVariables> {
    document = SaveSiteMessagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSiteMessagesDocument = gql`
    mutation UpdateSiteMessages($accountID: Int, $siteMessage: RDSMessageInput) {
  updateSiteMessage(accountID: $accountID, siteMessage: $siteMessage) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSiteMessagesGQL extends Apollo.Mutation<UpdateSiteMessagesMutation, UpdateSiteMessagesMutationVariables> {
    document = UpdateSiteMessagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SiteMessageDocument = gql`
    query SiteMessage($accountID: Int) {
  scanSiteMessages(accountID: $accountID) {
    id
    userId
    submitTimestamp
    title
    message
    status
    level
    sitePlacement
    endDate
    startDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteMessageGQL extends Apollo.Query<SiteMessageQuery, SiteMessageQueryVariables> {
    document = SiteMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSiteMessageDocument = gql`
    mutation DeleteSiteMessage($accountID: Int, $messageId: Int) {
  deleteSiteMessage(accountID: $accountID, messageId: $messageId) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSiteMessageGQL extends Apollo.Mutation<DeleteSiteMessageMutation, DeleteSiteMessageMutationVariables> {
    document = DeleteSiteMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const YtdSalesDocument = gql`
    query ytdSales($accountIds: [Int]!) {
  ytdSales(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class YtdSalesGQL extends Apollo.Query<YtdSalesQuery, YtdSalesQueryVariables> {
    document = YtdSalesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingAuctionsDocument = gql`
    query getUpcomingAuctions($accountIds: [Int]!, $limit: Int) {
  upcomingAuctions(accountIds: $accountIds, limit: $limit) {
    ...SaleSummary
    sellerHasItems
  }
}
    ${SaleSummaryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingAuctionsGQL extends Apollo.Query<GetUpcomingAuctionsQuery, GetUpcomingAuctionsQueryVariables> {
    document = GetUpcomingAuctionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRecentAuctionsDocument = gql`
    query getRecentAuctions($buyerAccountIds: [Int], $sellerAccountIds: [Int], $limit: Int) {
  recentAuctions(
    buyerAccountIds: $buyerAccountIds
    sellerAccountIds: $sellerAccountIds
    limit: $limit
  ) {
    sale {
      ...SaleSummary
      itemCount
    }
    payout {
      id
      accountId
      payoutStatus
      saleId
      sellerNet
      totalLots
      sale {
        payoutsFinalized
      }
    }
    invoice {
      id
      accountId
      invoiceTotal
    }
  }
}
    ${SaleSummaryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRecentAuctionsGQL extends Apollo.Query<GetRecentAuctionsQuery, GetRecentAuctionsQueryVariables> {
    document = GetRecentAuctionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInventoryManagementDetailsDocument = gql`
    query getInventoryManagementDetails($accountIds: [Int]!) {
  inventoryManagementDetails(accountIds: $accountIds) {
    notOnSite
    conditionPending
    awaitingTitle
    auctionReady
    needsDecommissioning
    assignedItems
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInventoryManagementDetailsGQL extends Apollo.Query<GetInventoryManagementDetailsQuery, GetInventoryManagementDetailsQueryVariables> {
    document = GetInventoryManagementDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEstimatedPurchaseBalanceDocument = gql`
    query getEstimatedPurchaseBalance($accountIds: [Int]) {
  estimatedPurchaseBalance(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEstimatedPurchaseBalanceGQL extends Apollo.Query<GetEstimatedPurchaseBalanceQuery, GetEstimatedPurchaseBalanceQueryVariables> {
    document = GetEstimatedPurchaseBalanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentRegisteredAuctionsDocument = gql`
    query getCurrentRegisteredAuctions($searchObject: InvoiceSearchRequest!) {
  currentRegisteredAuctions(searchObject: $searchObject)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentRegisteredAuctionsGQL extends Apollo.Query<GetCurrentRegisteredAuctionsQuery, GetCurrentRegisteredAuctionsQueryVariables> {
    document = GetCurrentRegisteredAuctionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotOnSiteCountDocument = gql`
    query getNotOnSiteCount($accountIds: [Int]!) {
  notOnSiteCount(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotOnSiteCountGQL extends Apollo.Query<GetNotOnSiteCountQuery, GetNotOnSiteCountQueryVariables> {
    document = GetNotOnSiteCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConditionPendingCountDocument = gql`
    query getConditionPendingCount($accountIds: [Int]!) {
  conditionPendingCount(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConditionPendingCountGQL extends Apollo.Query<GetConditionPendingCountQuery, GetConditionPendingCountQueryVariables> {
    document = GetConditionPendingCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAwaitingTitleCountDocument = gql`
    query getAwaitingTitleCount($accountIds: [Int]!) {
  awaitingTitleCount(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAwaitingTitleCountGQL extends Apollo.Query<GetAwaitingTitleCountQuery, GetAwaitingTitleCountQueryVariables> {
    document = GetAwaitingTitleCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuctionReadyCountDocument = gql`
    query getAuctionReadyCount($accountIds: [Int]!) {
  auctionReadyCount(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuctionReadyCountGQL extends Apollo.Query<GetAuctionReadyCountQuery, GetAuctionReadyCountQueryVariables> {
    document = GetAuctionReadyCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNeedsDecommissioningCountDocument = gql`
    query getNeedsDecommissioningCount($accountIds: [Int]!) {
  needsDecommissioningCount(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNeedsDecommissioningCountGQL extends Apollo.Query<GetNeedsDecommissioningCountQuery, GetNeedsDecommissioningCountQueryVariables> {
    document = GetNeedsDecommissioningCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssignedItemsCountDocument = gql`
    query getAssignedItemsCount($accountIds: [Int]!) {
  assignedItemsCount(accountIds: $accountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignedItemsCountGQL extends Apollo.Query<GetAssignedItemsCountQuery, GetAssignedItemsCountQueryVariables> {
    document = GetAssignedItemsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchInvoicesDocument = gql`
    query searchInvoices($searchObject: InvoiceSearchRequest!) {
  searchInvoices(searchObject: $searchObject) {
    number
    totalElements
    content {
      id
      accountId
      invoiceNumber
      invoiceTotal
      bidderNumber
      invoiceBalance
      invoiceTotal
      sale {
        date
        city
        state
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchInvoicesGQL extends Apollo.Query<SearchInvoicesQuery, SearchInvoicesQueryVariables> {
    document = SearchInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceSaleLocationsDocument = gql`
    query invoiceSaleLocations($accountIds: [Int]) {
  invoiceSaleLocations(accountIds: $accountIds) {
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceSaleLocationsGQL extends Apollo.Query<InvoiceSaleLocationsQuery, InvoiceSaleLocationsQueryVariables> {
    document = InvoiceSaleLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchItemsDocument = gql`
    query searchItems($searchObject: SearchItems!) {
  searchItems(searchObject: $searchObject) {
    number
    pageSize
    totalElements
    last
    first
    totalPages
    numberOfElements
    ... on ItemsSearchResponse {
      content {
        id
        amountOwed
        bidderBuyerInvoiceId
        buyerAccountId
        buyersTotal
        catalogDescription
        category
        engine
        fuel
        haveTitle
        height
        imageCount
        itemId
        itemStatus
        lotNumber
        make
        model
        mounted
        odometer
        offSitePhysicalCity
        offSitePhysicalState
        offSitePhysicalZip
        parentCategory
        sale {
          payoutsFinalized
        }
        saleDate
        saleId
        saleInfo
        saleName
        salePrice
        saleType
        sellerPayoutId
        titled
        transmission
        unitNumber
        upperMake
        upperModel
        upperOptionalEquipment
        upperSerialNumber
        vin
        year
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchItemsGQL extends Apollo.Query<SearchItemsQuery, SearchItemsQueryVariables> {
    document = SearchItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SellerFilterOptionsDocument = gql`
    query sellerFilterOptions($accountIds: [Int]) {
  sellerFilterOptions(accountIds: $accountIds) {
    saleInfo {
      name
      description
    }
    offSitePhysical {
      name
      description
    }
    category {
      name
      description
    }
    make {
      name
      description
    }
    model {
      name
      description
    }
    upperMake {
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SellerFilterOptionsGQL extends Apollo.Query<SellerFilterOptionsQuery, SellerFilterOptionsQueryVariables> {
    document = SellerFilterOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BuyerFilterOptionsDocument = gql`
    query buyerFilterOptions($accountIds: [Int]) {
  buyerFilterOptions(accountIds: $accountIds) {
    saleInfo {
      name
      description
    }
    offSitePhysical {
      name
      description
    }
    category {
      name
      description
    }
    make {
      name
      description
    }
    model {
      name
      description
    }
    upperMake {
      name
      description
    }
    upperModel {
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BuyerFilterOptionsGQL extends Apollo.Query<BuyerFilterOptionsQuery, BuyerFilterOptionsQueryVariables> {
    document = BuyerFilterOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ItemDetailsDocument = gql`
    query itemDetails($sellerAccountIds: [Int], $buyerAccountIds: [Int], $itemId: Int!) {
  itemDetails(
    sellerAccountIds: $sellerAccountIds
    buyerAccountIds: $buyerAccountIds
    itemId: $itemId
  ) {
    id
    unitNumber
    itemStatus
    needsDecomm
    decommComplete
    salePrice
    lotNumber
    saleInfo
    saleType
    saleDate
    catalogDescription
    category
    vin
    year
    make
    model
    itemId
    engine
    fuel
    transmission
    odometer
    upperSerialNumber
    upperMake
    upperModel
    height
    mounted
    upperOptionalEquipment
    plateNumber
    conditions
    optionalEquipment
    capacity
    capacityType
    upperFuel
    hours
    offSite
    offSitePhysicalCity
    offSitePhysicalState
    offSitePhysicalZip
    commission
    expenseTransportation
    expenseWashing
    expenseDecommission
    adjustmentAmount
    expensePartsRepairs
    expenseMisc1
    expenseMisc2
    amountOwed
    imageUrls
    haveTitle
    titled
    inspectionDate
    titleReceivedDate
    createDate
    sellerPayoutId
    bidderBuyerInvoiceId
    bidderNumber
    buyerFee
    tax
    caWeightFee
    caLicenseFee
    titleFee
    fee1aActual
    fee1Actual
    fee2aActual
    fee2Actual
    fee3Actual
    fee4Actual
    fee5Actual
    fee6Actual
    fee7Actual
    fee8Actual
    fee9Actual
    sale {
      payoutsFinalized
      fee1ADescription
      fee1Description
      fee2Description
      fee3Description
      fee4Description
      fee5Description
      fee6Description
      fee7Description
      fee8Description
      fee9Description
    }
    saleId
    buyerAccountId
    arrivalDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ItemDetailsGQL extends Apollo.Query<ItemDetailsQuery, ItemDetailsQueryVariables> {
    document = ItemDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSellerItemsExportDataDocument = gql`
    query getSellerItemsExportData($searchObject: SearchItems!, $exportStartPage: Int!, $exportEndPage: Int!) {
  exportItems(
    searchObject: $searchObject
    exportStartPage: $exportStartPage
    exportEndPage: $exportEndPage
  ) {
    id
    arrivalDate
    conditions
    haveTitle
    itemStatus
    unitNumber
    category
    vin
    year
    make
    model
    lotNumber
    saleInfo
    saleType
    saleDate
    offSitePhysicalCity
    offSitePhysicalState
    itemStatus
    catalogDescription
    plateNumber
    engine
    fuel
    transmission
    titled
    odometer
    hours
    conditions
    optionalEquipment
    upperSerialNumber
    upperMake
    upperModel
    upperFuel
    height
    capacity
    mounted
    upperOptionalEquipment
    amountOwed
    salePrice
    sale {
      payoutsFinalized
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSellerItemsExportDataGQL extends Apollo.Query<GetSellerItemsExportDataQuery, GetSellerItemsExportDataQueryVariables> {
    document = GetSellerItemsExportDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBuyerItemsExportDataDocument = gql`
    query getBuyerItemsExportData($searchObject: SearchItems!, $exportStartPage: Int!, $exportEndPage: Int!) {
  exportItems(
    searchObject: $searchObject
    exportStartPage: $exportStartPage
    exportEndPage: $exportEndPage
  ) {
    id
    lotNumber
    saleName
    saleDate
    parentCategory
    category
    catalogDescription
    vin
    upperSerialNumber
    odometer
    hours
    titled
    buyerPickupDate
    offSitePhysicalCity
    offSitePhysicalState
    offSitePhysicalZip
    salePrice
    buyersTotal
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBuyerItemsExportDataGQL extends Apollo.Query<GetBuyerItemsExportDataQuery, GetBuyerItemsExportDataQueryVariables> {
    document = GetBuyerItemsExportDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($forgotPasswordObject: ForgotPassword) {
  forgotPassword(forgotPasswordObject: $forgotPasswordObject) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgotPasswordGQL extends Apollo.Mutation<ForgotPasswordMutation, ForgotPasswordMutationVariables> {
    document = ForgotPasswordDocument;
    client = 'noAuthClient';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchPayoutsDocument = gql`
    query searchPayouts($searchRequest: PayoutSearchRequest!) {
  searchPayouts(searchRequest: $searchRequest) {
    numberOfElements
    totalElements
    content {
      ...Payout
    }
  }
}
    ${PayoutFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchPayoutsGQL extends Apollo.Query<SearchPayoutsQuery, SearchPayoutsQueryVariables> {
    document = SearchPayoutsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayoutDetailsDocument = gql`
    query getPayoutDetails($accountIds: [Int]!, $payoutId: Int!) {
  payoutDetails(accountIds: $accountIds, payoutId: $payoutId) {
    numberOfElements
    totalElements
    content {
      ...Payout
    }
  }
}
    ${PayoutFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayoutDetailsGQL extends Apollo.Query<GetPayoutDetailsQuery, GetPayoutDetailsQueryVariables> {
    document = GetPayoutDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayoutFiltersDocument = gql`
    query getPayoutFilters($accountIds: [Int]!) {
  payoutFilters(accountIds: $accountIds) {
    sale {
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayoutFiltersGQL extends Apollo.Query<GetPayoutFiltersQuery, GetPayoutFiltersQueryVariables> {
    document = GetPayoutFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessCodesDocument = gql`
    query getBusinessCodes {
  businessCodes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessCodesGQL extends Apollo.Query<GetBusinessCodesQuery, GetBusinessCodesQueryVariables> {
    document = GetBusinessCodesDocument;
    client = 'noAuthClient';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeocodeDocument = gql`
    query geocode($zip: String!) {
  geocode(zip: $zip) {
    success
    objects {
      city
      county
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeocodeGQL extends Apollo.Query<GeocodeQuery, GeocodeQueryVariables> {
    document = GeocodeDocument;
    client = 'noAuthClient';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDocument = gql`
    mutation register($registrationObject: Registration!) {
  register(registrationObject: $registrationObject) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterGQL extends Apollo.Mutation<RegisterMutation, RegisterMutationVariables> {
    document = RegisterDocument;
    client = 'noAuthClient';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateUserDocument = gql`
    mutation activateUser($token: String!) {
  activateUser(token: $token) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateUserGQL extends Apollo.Mutation<ActivateUserMutation, ActivateUserMutationVariables> {
    document = ActivateUserDocument;
    client = 'noAuthClient';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query getCountries {
  countries {
    code
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    client = 'noAuthClient';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContactInfoDocument = gql`
    query getContactInfo($type: String) {
  profiles(type: $type) {
    parentAccountId
    defaultContact
    accountInfo {
      firstName
      lastName
      address
      city
      state
      zip
      county
      country
      phoneNumber
      phoneType
      email
      sellerCode
      companyInfo {
        companyName
        companyId
        companyPhone
        companyCity
        companyCountry
        companyAddress
        companyState
        companyZip
      }
      supportContact {
        firstName
        lastName
        email
        phoneNumber
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContactInfoGQL extends Apollo.Query<GetContactInfoQuery, GetContactInfoQueryVariables> {
    document = GetContactInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendContactUsMessageMutationDocument = gql`
    mutation sendContactUsMessageMutation($messageObject: ContactUsMessage) {
  sendContactUsMessage(messageObject: $messageObject) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendContactUsMessageMutationGQL extends Apollo.Mutation<SendContactUsMessageMutationMutation, SendContactUsMessageMutationMutationVariables> {
    document = SendContactUsMessageMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDropdownValuesDocument = gql`
    query getDropdownValues {
  categories {
    name
  }
  subcategories {
    id
    name
    parentCategoryName
    combination
  }
  makeAndModel {
    make
    models
  }
  engines {
    id
    name
  }
  fuel {
    id
    name
  }
  transmissions {
    id
    name
  }
  upperMakeAndModel {
    make
    models
  }
  upperFuel {
    id
    name
  }
  capacity {
    id
    name
    description
    type
  }
  mounted {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDropdownValuesGQL extends Apollo.Query<GetDropdownValuesQuery, GetDropdownValuesQueryVariables> {
    document = GetDropdownValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveItemDocument = gql`
    mutation saveItem($accountId: Int!, $contactId: Int!, $auctionItem: AuctionItemInput!) {
  saveAuctionItem(
    accountId: $accountId
    contactId: $contactId
    auctionItem: $auctionItem
  ) {
    id
    saleId
    make
    model
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveItemGQL extends Apollo.Mutation<SaveItemMutation, SaveItemMutationVariables> {
    document = SaveItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DraftItemsDocument = gql`
    query DraftItems($accountIds: [Int], $searchOptions: SearchOptions) {
  queryDraftItems(accountIds: $accountIds, searchOptions: $searchOptions) {
    records {
      id
      userId
      currentStep
      itemType
      submitTimestamp
      parentCategory
      category
      vin
      year
      make
      model
      sellerFleetNumber2
      plateNumber
      engine
      fuel
      transmission
      odometer
      hours
      optionalEquipment
      airConditioning
      unitNumber
      upperSerialNumber
      upperMake
      upperModel
      upperFuel
      height
      capacity
      capacityUnit
      capacityType
      mounted
      upperOptionalEquipment
      itemNotes
      offSitePhysicalAddress
      offSitePhysicalCity
      offSitePhysicalState
      offSitePhysicalZip
      taxCounty
      titled
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DraftItemsGQL extends Apollo.Query<DraftItemsQuery, DraftItemsQueryVariables> {
    document = DraftItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DraftFilterValuesDocument = gql`
    query draftFilterValues($accountIds: [Int]) {
  draftFilterValues(accountIds: $accountIds) {
    category
    make
    model
    upperMake
    upperModel
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DraftFilterValuesGQL extends Apollo.Query<DraftFilterValuesQuery, DraftFilterValuesQueryVariables> {
    document = DraftFilterValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveDraftItemsDocument = gql`
    mutation SaveDraftItems($draftItem: RDSDraftItemInput) {
  saveDraftItem(draftItem: $draftItem) {
    test
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveDraftItemsGQL extends Apollo.Mutation<SaveDraftItemsMutation, SaveDraftItemsMutationVariables> {
    document = SaveDraftItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDraftItemDocument = gql`
    mutation updateDraftItem($draftItem: RDSDraftItemInput) {
  updateDraftItem(draftItem: $draftItem) {
    test
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDraftItemGQL extends Apollo.Mutation<UpdateDraftItemMutation, UpdateDraftItemMutationVariables> {
    document = UpdateDraftItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDraftItemDocument = gql`
    mutation DeleteDraftItem($draftId: Int) {
  deleteDraftItem(draftId: $draftId) {
    test
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDraftItemGQL extends Apollo.Mutation<DeleteDraftItemMutation, DeleteDraftItemMutationVariables> {
    document = DeleteDraftItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

  type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

  interface WatchQueryOptionsAlone<V> extends Omit<ApolloCore.WatchQueryOptions<V>, 'query' | 'variables'> {}

  interface QueryOptionsAlone<V> extends Omit<ApolloCore.QueryOptions<V>, 'query' | 'variables'> {}

  interface MutationOptionsAlone<T, V> extends Omit<ApolloCore.MutationOptions<T, V>, 'mutation' | 'variables'> {}

  @Injectable({ providedIn: 'root' })
  export class JjkIntegration {
    constructor(
      private saveSiteMessagesGql: SaveSiteMessagesGQL,
      private updateSiteMessagesGql: UpdateSiteMessagesGQL,
      private siteMessageGql: SiteMessageGQL,
      private deleteSiteMessageGql: DeleteSiteMessageGQL,
      private ytdSalesGql: YtdSalesGQL,
      private getUpcomingAuctionsGql: GetUpcomingAuctionsGQL,
      private getRecentAuctionsGql: GetRecentAuctionsGQL,
      private getInventoryManagementDetailsGql: GetInventoryManagementDetailsGQL,
      private getEstimatedPurchaseBalanceGql: GetEstimatedPurchaseBalanceGQL,
      private getCurrentRegisteredAuctionsGql: GetCurrentRegisteredAuctionsGQL,
      private getNotOnSiteCountGql: GetNotOnSiteCountGQL,
      private getConditionPendingCountGql: GetConditionPendingCountGQL,
      private getAwaitingTitleCountGql: GetAwaitingTitleCountGQL,
      private getAuctionReadyCountGql: GetAuctionReadyCountGQL,
      private getNeedsDecommissioningCountGql: GetNeedsDecommissioningCountGQL,
      private getAssignedItemsCountGql: GetAssignedItemsCountGQL,
      private searchInvoicesGql: SearchInvoicesGQL,
      private invoiceSaleLocationsGql: InvoiceSaleLocationsGQL,
      private searchItemsGql: SearchItemsGQL,
      private sellerFilterOptionsGql: SellerFilterOptionsGQL,
      private buyerFilterOptionsGql: BuyerFilterOptionsGQL,
      private itemDetailsGql: ItemDetailsGQL,
      private getSellerItemsExportDataGql: GetSellerItemsExportDataGQL,
      private getBuyerItemsExportDataGql: GetBuyerItemsExportDataGQL,
      private forgotPasswordGql: ForgotPasswordGQL,
      private searchPayoutsGql: SearchPayoutsGQL,
      private getPayoutDetailsGql: GetPayoutDetailsGQL,
      private getPayoutFiltersGql: GetPayoutFiltersGQL,
      private getBusinessCodesGql: GetBusinessCodesGQL,
      private geocodeGql: GeocodeGQL,
      private registerGql: RegisterGQL,
      private activateUserGql: ActivateUserGQL,
      private getCountriesGql: GetCountriesGQL,
      private getContactInfoGql: GetContactInfoGQL,
      private sendContactUsMessageMutationGql: SendContactUsMessageMutationGQL,
      private getDropdownValuesGql: GetDropdownValuesGQL,
      private saveItemGql: SaveItemGQL,
      private draftItemsGql: DraftItemsGQL,
      private draftFilterValuesGql: DraftFilterValuesGQL,
      private saveDraftItemsGql: SaveDraftItemsGQL,
      private updateDraftItemGql: UpdateDraftItemGQL,
      private deleteDraftItemGql: DeleteDraftItemGQL
    ) {}
      
    saveSiteMessages(variables?: SaveSiteMessagesMutationVariables, options?: MutationOptionsAlone<SaveSiteMessagesMutation, SaveSiteMessagesMutationVariables>) {
      return this.saveSiteMessagesGql.mutate(variables, options)
    }
    
    updateSiteMessages(variables?: UpdateSiteMessagesMutationVariables, options?: MutationOptionsAlone<UpdateSiteMessagesMutation, UpdateSiteMessagesMutationVariables>) {
      return this.updateSiteMessagesGql.mutate(variables, options)
    }
    
    siteMessage(variables?: SiteMessageQueryVariables, options?: QueryOptionsAlone<SiteMessageQueryVariables>) {
      return this.siteMessageGql.fetch(variables, options)
    }
    
    siteMessageWatch(variables?: SiteMessageQueryVariables, options?: WatchQueryOptionsAlone<SiteMessageQueryVariables>) {
      return this.siteMessageGql.watch(variables, options)
    }
    
    deleteSiteMessage(variables?: DeleteSiteMessageMutationVariables, options?: MutationOptionsAlone<DeleteSiteMessageMutation, DeleteSiteMessageMutationVariables>) {
      return this.deleteSiteMessageGql.mutate(variables, options)
    }
    
    ytdSales(variables: YtdSalesQueryVariables, options?: QueryOptionsAlone<YtdSalesQueryVariables>) {
      return this.ytdSalesGql.fetch(variables, options)
    }
    
    ytdSalesWatch(variables: YtdSalesQueryVariables, options?: WatchQueryOptionsAlone<YtdSalesQueryVariables>) {
      return this.ytdSalesGql.watch(variables, options)
    }
    
    getUpcomingAuctions(variables: GetUpcomingAuctionsQueryVariables, options?: QueryOptionsAlone<GetUpcomingAuctionsQueryVariables>) {
      return this.getUpcomingAuctionsGql.fetch(variables, options)
    }
    
    getUpcomingAuctionsWatch(variables: GetUpcomingAuctionsQueryVariables, options?: WatchQueryOptionsAlone<GetUpcomingAuctionsQueryVariables>) {
      return this.getUpcomingAuctionsGql.watch(variables, options)
    }
    
    getRecentAuctions(variables?: GetRecentAuctionsQueryVariables, options?: QueryOptionsAlone<GetRecentAuctionsQueryVariables>) {
      return this.getRecentAuctionsGql.fetch(variables, options)
    }
    
    getRecentAuctionsWatch(variables?: GetRecentAuctionsQueryVariables, options?: WatchQueryOptionsAlone<GetRecentAuctionsQueryVariables>) {
      return this.getRecentAuctionsGql.watch(variables, options)
    }
    
    getInventoryManagementDetails(variables: GetInventoryManagementDetailsQueryVariables, options?: QueryOptionsAlone<GetInventoryManagementDetailsQueryVariables>) {
      return this.getInventoryManagementDetailsGql.fetch(variables, options)
    }
    
    getInventoryManagementDetailsWatch(variables: GetInventoryManagementDetailsQueryVariables, options?: WatchQueryOptionsAlone<GetInventoryManagementDetailsQueryVariables>) {
      return this.getInventoryManagementDetailsGql.watch(variables, options)
    }
    
    getEstimatedPurchaseBalance(variables?: GetEstimatedPurchaseBalanceQueryVariables, options?: QueryOptionsAlone<GetEstimatedPurchaseBalanceQueryVariables>) {
      return this.getEstimatedPurchaseBalanceGql.fetch(variables, options)
    }
    
    getEstimatedPurchaseBalanceWatch(variables?: GetEstimatedPurchaseBalanceQueryVariables, options?: WatchQueryOptionsAlone<GetEstimatedPurchaseBalanceQueryVariables>) {
      return this.getEstimatedPurchaseBalanceGql.watch(variables, options)
    }
    
    getCurrentRegisteredAuctions(variables: GetCurrentRegisteredAuctionsQueryVariables, options?: QueryOptionsAlone<GetCurrentRegisteredAuctionsQueryVariables>) {
      return this.getCurrentRegisteredAuctionsGql.fetch(variables, options)
    }
    
    getCurrentRegisteredAuctionsWatch(variables: GetCurrentRegisteredAuctionsQueryVariables, options?: WatchQueryOptionsAlone<GetCurrentRegisteredAuctionsQueryVariables>) {
      return this.getCurrentRegisteredAuctionsGql.watch(variables, options)
    }
    
    getNotOnSiteCount(variables: GetNotOnSiteCountQueryVariables, options?: QueryOptionsAlone<GetNotOnSiteCountQueryVariables>) {
      return this.getNotOnSiteCountGql.fetch(variables, options)
    }
    
    getNotOnSiteCountWatch(variables: GetNotOnSiteCountQueryVariables, options?: WatchQueryOptionsAlone<GetNotOnSiteCountQueryVariables>) {
      return this.getNotOnSiteCountGql.watch(variables, options)
    }
    
    getConditionPendingCount(variables: GetConditionPendingCountQueryVariables, options?: QueryOptionsAlone<GetConditionPendingCountQueryVariables>) {
      return this.getConditionPendingCountGql.fetch(variables, options)
    }
    
    getConditionPendingCountWatch(variables: GetConditionPendingCountQueryVariables, options?: WatchQueryOptionsAlone<GetConditionPendingCountQueryVariables>) {
      return this.getConditionPendingCountGql.watch(variables, options)
    }
    
    getAwaitingTitleCount(variables: GetAwaitingTitleCountQueryVariables, options?: QueryOptionsAlone<GetAwaitingTitleCountQueryVariables>) {
      return this.getAwaitingTitleCountGql.fetch(variables, options)
    }
    
    getAwaitingTitleCountWatch(variables: GetAwaitingTitleCountQueryVariables, options?: WatchQueryOptionsAlone<GetAwaitingTitleCountQueryVariables>) {
      return this.getAwaitingTitleCountGql.watch(variables, options)
    }
    
    getAuctionReadyCount(variables: GetAuctionReadyCountQueryVariables, options?: QueryOptionsAlone<GetAuctionReadyCountQueryVariables>) {
      return this.getAuctionReadyCountGql.fetch(variables, options)
    }
    
    getAuctionReadyCountWatch(variables: GetAuctionReadyCountQueryVariables, options?: WatchQueryOptionsAlone<GetAuctionReadyCountQueryVariables>) {
      return this.getAuctionReadyCountGql.watch(variables, options)
    }
    
    getNeedsDecommissioningCount(variables: GetNeedsDecommissioningCountQueryVariables, options?: QueryOptionsAlone<GetNeedsDecommissioningCountQueryVariables>) {
      return this.getNeedsDecommissioningCountGql.fetch(variables, options)
    }
    
    getNeedsDecommissioningCountWatch(variables: GetNeedsDecommissioningCountQueryVariables, options?: WatchQueryOptionsAlone<GetNeedsDecommissioningCountQueryVariables>) {
      return this.getNeedsDecommissioningCountGql.watch(variables, options)
    }
    
    getAssignedItemsCount(variables: GetAssignedItemsCountQueryVariables, options?: QueryOptionsAlone<GetAssignedItemsCountQueryVariables>) {
      return this.getAssignedItemsCountGql.fetch(variables, options)
    }
    
    getAssignedItemsCountWatch(variables: GetAssignedItemsCountQueryVariables, options?: WatchQueryOptionsAlone<GetAssignedItemsCountQueryVariables>) {
      return this.getAssignedItemsCountGql.watch(variables, options)
    }
    
    searchInvoices(variables: SearchInvoicesQueryVariables, options?: QueryOptionsAlone<SearchInvoicesQueryVariables>) {
      return this.searchInvoicesGql.fetch(variables, options)
    }
    
    searchInvoicesWatch(variables: SearchInvoicesQueryVariables, options?: WatchQueryOptionsAlone<SearchInvoicesQueryVariables>) {
      return this.searchInvoicesGql.watch(variables, options)
    }
    
    invoiceSaleLocations(variables?: InvoiceSaleLocationsQueryVariables, options?: QueryOptionsAlone<InvoiceSaleLocationsQueryVariables>) {
      return this.invoiceSaleLocationsGql.fetch(variables, options)
    }
    
    invoiceSaleLocationsWatch(variables?: InvoiceSaleLocationsQueryVariables, options?: WatchQueryOptionsAlone<InvoiceSaleLocationsQueryVariables>) {
      return this.invoiceSaleLocationsGql.watch(variables, options)
    }
    
    searchItems(variables: SearchItemsQueryVariables, options?: QueryOptionsAlone<SearchItemsQueryVariables>) {
      return this.searchItemsGql.fetch(variables, options)
    }
    
    searchItemsWatch(variables: SearchItemsQueryVariables, options?: WatchQueryOptionsAlone<SearchItemsQueryVariables>) {
      return this.searchItemsGql.watch(variables, options)
    }
    
    sellerFilterOptions(variables?: SellerFilterOptionsQueryVariables, options?: QueryOptionsAlone<SellerFilterOptionsQueryVariables>) {
      return this.sellerFilterOptionsGql.fetch(variables, options)
    }
    
    sellerFilterOptionsWatch(variables?: SellerFilterOptionsQueryVariables, options?: WatchQueryOptionsAlone<SellerFilterOptionsQueryVariables>) {
      return this.sellerFilterOptionsGql.watch(variables, options)
    }
    
    buyerFilterOptions(variables?: BuyerFilterOptionsQueryVariables, options?: QueryOptionsAlone<BuyerFilterOptionsQueryVariables>) {
      return this.buyerFilterOptionsGql.fetch(variables, options)
    }
    
    buyerFilterOptionsWatch(variables?: BuyerFilterOptionsQueryVariables, options?: WatchQueryOptionsAlone<BuyerFilterOptionsQueryVariables>) {
      return this.buyerFilterOptionsGql.watch(variables, options)
    }
    
    itemDetails(variables: ItemDetailsQueryVariables, options?: QueryOptionsAlone<ItemDetailsQueryVariables>) {
      return this.itemDetailsGql.fetch(variables, options)
    }
    
    itemDetailsWatch(variables: ItemDetailsQueryVariables, options?: WatchQueryOptionsAlone<ItemDetailsQueryVariables>) {
      return this.itemDetailsGql.watch(variables, options)
    }
    
    getSellerItemsExportData(variables: GetSellerItemsExportDataQueryVariables, options?: QueryOptionsAlone<GetSellerItemsExportDataQueryVariables>) {
      return this.getSellerItemsExportDataGql.fetch(variables, options)
    }
    
    getSellerItemsExportDataWatch(variables: GetSellerItemsExportDataQueryVariables, options?: WatchQueryOptionsAlone<GetSellerItemsExportDataQueryVariables>) {
      return this.getSellerItemsExportDataGql.watch(variables, options)
    }
    
    getBuyerItemsExportData(variables: GetBuyerItemsExportDataQueryVariables, options?: QueryOptionsAlone<GetBuyerItemsExportDataQueryVariables>) {
      return this.getBuyerItemsExportDataGql.fetch(variables, options)
    }
    
    getBuyerItemsExportDataWatch(variables: GetBuyerItemsExportDataQueryVariables, options?: WatchQueryOptionsAlone<GetBuyerItemsExportDataQueryVariables>) {
      return this.getBuyerItemsExportDataGql.watch(variables, options)
    }
    
    forgotPassword(variables?: ForgotPasswordMutationVariables, options?: MutationOptionsAlone<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
      return this.forgotPasswordGql.mutate(variables, options)
    }
    
    searchPayouts(variables: SearchPayoutsQueryVariables, options?: QueryOptionsAlone<SearchPayoutsQueryVariables>) {
      return this.searchPayoutsGql.fetch(variables, options)
    }
    
    searchPayoutsWatch(variables: SearchPayoutsQueryVariables, options?: WatchQueryOptionsAlone<SearchPayoutsQueryVariables>) {
      return this.searchPayoutsGql.watch(variables, options)
    }
    
    getPayoutDetails(variables: GetPayoutDetailsQueryVariables, options?: QueryOptionsAlone<GetPayoutDetailsQueryVariables>) {
      return this.getPayoutDetailsGql.fetch(variables, options)
    }
    
    getPayoutDetailsWatch(variables: GetPayoutDetailsQueryVariables, options?: WatchQueryOptionsAlone<GetPayoutDetailsQueryVariables>) {
      return this.getPayoutDetailsGql.watch(variables, options)
    }
    
    getPayoutFilters(variables: GetPayoutFiltersQueryVariables, options?: QueryOptionsAlone<GetPayoutFiltersQueryVariables>) {
      return this.getPayoutFiltersGql.fetch(variables, options)
    }
    
    getPayoutFiltersWatch(variables: GetPayoutFiltersQueryVariables, options?: WatchQueryOptionsAlone<GetPayoutFiltersQueryVariables>) {
      return this.getPayoutFiltersGql.watch(variables, options)
    }
    
    getBusinessCodes(variables?: GetBusinessCodesQueryVariables, options?: QueryOptionsAlone<GetBusinessCodesQueryVariables>) {
      return this.getBusinessCodesGql.fetch(variables, options)
    }
    
    getBusinessCodesWatch(variables?: GetBusinessCodesQueryVariables, options?: WatchQueryOptionsAlone<GetBusinessCodesQueryVariables>) {
      return this.getBusinessCodesGql.watch(variables, options)
    }
    
    geocode(variables: GeocodeQueryVariables, options?: QueryOptionsAlone<GeocodeQueryVariables>) {
      return this.geocodeGql.fetch(variables, options)
    }
    
    geocodeWatch(variables: GeocodeQueryVariables, options?: WatchQueryOptionsAlone<GeocodeQueryVariables>) {
      return this.geocodeGql.watch(variables, options)
    }
    
    register(variables: RegisterMutationVariables, options?: MutationOptionsAlone<RegisterMutation, RegisterMutationVariables>) {
      return this.registerGql.mutate(variables, options)
    }
    
    activateUser(variables: ActivateUserMutationVariables, options?: MutationOptionsAlone<ActivateUserMutation, ActivateUserMutationVariables>) {
      return this.activateUserGql.mutate(variables, options)
    }
    
    getCountries(variables?: GetCountriesQueryVariables, options?: QueryOptionsAlone<GetCountriesQueryVariables>) {
      return this.getCountriesGql.fetch(variables, options)
    }
    
    getCountriesWatch(variables?: GetCountriesQueryVariables, options?: WatchQueryOptionsAlone<GetCountriesQueryVariables>) {
      return this.getCountriesGql.watch(variables, options)
    }
    
    getContactInfo(variables?: GetContactInfoQueryVariables, options?: QueryOptionsAlone<GetContactInfoQueryVariables>) {
      return this.getContactInfoGql.fetch(variables, options)
    }
    
    getContactInfoWatch(variables?: GetContactInfoQueryVariables, options?: WatchQueryOptionsAlone<GetContactInfoQueryVariables>) {
      return this.getContactInfoGql.watch(variables, options)
    }
    
    sendContactUsMessageMutation(variables?: SendContactUsMessageMutationMutationVariables, options?: MutationOptionsAlone<SendContactUsMessageMutationMutation, SendContactUsMessageMutationMutationVariables>) {
      return this.sendContactUsMessageMutationGql.mutate(variables, options)
    }
    
    getDropdownValues(variables?: GetDropdownValuesQueryVariables, options?: QueryOptionsAlone<GetDropdownValuesQueryVariables>) {
      return this.getDropdownValuesGql.fetch(variables, options)
    }
    
    getDropdownValuesWatch(variables?: GetDropdownValuesQueryVariables, options?: WatchQueryOptionsAlone<GetDropdownValuesQueryVariables>) {
      return this.getDropdownValuesGql.watch(variables, options)
    }
    
    saveItem(variables: SaveItemMutationVariables, options?: MutationOptionsAlone<SaveItemMutation, SaveItemMutationVariables>) {
      return this.saveItemGql.mutate(variables, options)
    }
    
    draftItems(variables?: DraftItemsQueryVariables, options?: QueryOptionsAlone<DraftItemsQueryVariables>) {
      return this.draftItemsGql.fetch(variables, options)
    }
    
    draftItemsWatch(variables?: DraftItemsQueryVariables, options?: WatchQueryOptionsAlone<DraftItemsQueryVariables>) {
      return this.draftItemsGql.watch(variables, options)
    }
    
    draftFilterValues(variables?: DraftFilterValuesQueryVariables, options?: QueryOptionsAlone<DraftFilterValuesQueryVariables>) {
      return this.draftFilterValuesGql.fetch(variables, options)
    }
    
    draftFilterValuesWatch(variables?: DraftFilterValuesQueryVariables, options?: WatchQueryOptionsAlone<DraftFilterValuesQueryVariables>) {
      return this.draftFilterValuesGql.watch(variables, options)
    }
    
    saveDraftItems(variables?: SaveDraftItemsMutationVariables, options?: MutationOptionsAlone<SaveDraftItemsMutation, SaveDraftItemsMutationVariables>) {
      return this.saveDraftItemsGql.mutate(variables, options)
    }
    
    updateDraftItem(variables?: UpdateDraftItemMutationVariables, options?: MutationOptionsAlone<UpdateDraftItemMutation, UpdateDraftItemMutationVariables>) {
      return this.updateDraftItemGql.mutate(variables, options)
    }
    
    deleteDraftItem(variables?: DeleteDraftItemMutationVariables, options?: MutationOptionsAlone<DeleteDraftItemMutation, DeleteDraftItemMutationVariables>) {
      return this.deleteDraftItemGql.mutate(variables, options)
    }
  }